import { mapActions, mapGetters } from 'vuex'
import i18n from '../i18n'

const showMessage = {
  methods: {
    ...mapActions('snackbarModule', ['showMessage', 'showHttpErrorMessage', 'showHttpErrorLongTimeMessage'])
  }
}

const loading = {
  computed: {
    ...mapGetters(['isLoading'])
  },
  methods: {
    ...mapActions(['changeLoadingStatus'])
  }
}

const rules = {
  data: () => ({
    rules: {
      required: (v, message) => (!!v || v.toString() === '0') || (message || i18n.t('rule.required.field')),
      offerPrice: (v) => (/^[0-9]+(\.[0-9]{1,2})?$/.test(v) && v > 0) || i18n.t('rule.invalid.offer'),
      maxPrice: (v, max) => (v <= max || i18n.t('rule.invalid.maxPrice', { max: max })),
      maxValue: (v, max) => (parseFloat(v) <= parseFloat(max) || i18n.t('rule.invalid.maxValue', { max })),
      minValue: (v, min) => (parseFloat(v) > parseFloat(min) || i18n.t('rule.invalid.minValue', { min })),
      repeatPassword: (v1, v2) => (v1 === v2) || i18n.t('rule.invalid.repeatPassword'),
      minCharacters: (v, min) => (v?.toString().length >= min) || i18n.t('rule.invalid.minCharacters', { num: min }),
      maxCharacters: (v, max) => (v?.toString().length <= max) || i18n.t('rule.invalid.maxCharacters', { num: max }),
      number: (v, message) => !isNaN(v) || (message || i18n.t('rule.invalid.number')),
      decimalQuantity3: (v, message) => (/^[0-9]+(\.[0-9]{1,3})?$/.test(v)) || (message || i18n.t('rule.invalid.number')),
      atLeastOne: (v, message) => (Array.isArray(v) && v.length > 0) || (!Array.isArray(v) && !!v) || (message || i18n.t('rule.invalid.atLeastOne')),
      alphanumeric: (v, message) => (/^[a-zA-Z0-9]*$/).test(v) || (message || i18n.t('rule.invalid.onlyAlphanumeric')),
      positiveInteger: (v) => (!isNaN(v) && v % 1 === 0 && Number.isInteger(parseInt(v)) && v > 0) || i18n.t('rule.invalid.positiveInteger')
    }
  })
}

const appModule = {
  computed: {
    ...mapGetters(['appModule'])
  },
  methods: {
    ...mapActions(['changeAppModule'])
  }
}

const userInfo = {
  computed: {
    ...mapGetters('loginModule', ['userInfo'])
  }
}

export { loading, showMessage, rules, userInfo, appModule }
